import { Outlet } from 'react-router';
import Page from '~/components/layout/page/Page';
import LineItem from '~/components/LineItem';
import { useLoaderData } from './draftClaimLineItem';

export default function DraftClaimLayout() {
  const {
    draftClaimLineItem: { lineItem },
  } = useLoaderData();

  return (
    <Page.Root
      title={`${lineItem.name ?? 'Line Item'} Information Collection`}
      hideHeader
    >
      <Page.Section>
        <LineItem
          name={lineItem.name ?? ''}
          price={lineItem.unitPrice}
          imgSrc={lineItem.imgUrl}
          options={lineItem.optionsFromPlatform}
          footnote={
            lineItem.return.isExchangeOnly && (
              <span className="text-critical">Exchange Only</span>
            )
          }
          variant="small"
        />
      </Page.Section>

      <Outlet />
    </Page.Root>
  );
}
